import { useEffect } from "react";

export const useBreadcrumbUpdates = breadcrumbs => {
  useEffect(() => {
    window.asos.siteChrome.setBreadcrumbs(breadcrumbs);
  }, [breadcrumbs]);
};
